// Base content structure for image-based mockImages
const baseMockImagesContent = {
  type: "image",
  inputType: "",
  label: "",
  data: {
    id: "",
    key: "",
    value: "",
    type: "howToPlay",
    file: {},
    isUpdated: false,
  },
  translation: { input: "", flag: false, isUpdated: false },
};

// Helper function to create a rating entry
const createRatingEntry = (title: string, key: string) => ({
  title,
  content: {
    ...baseMockImagesContent,
    data: {
      ...baseMockImagesContent.data,
      key,
    },
  },
  isRequired: false,
  readonly: false,
  isButton: true,
});

// Mock Image entries
const mockImagesEntries = [
  { title: "Mock Image 1", key: "mockImage1" },
  { title: "Mock Image 2", key: "mockImage2" },
  { title: "Mock Image 3", key: "mockImage3" },
  { title: "Mock Image 4", key: "mockImage4" },
  { title: "Mock Image 5", key: "mockImage5" },
  { title: "Mock Image 6", key: "mockImage6" },
];

// Generate mockImages array
const mockImages = mockImagesEntries.map(({ title, key }) => createRatingEntry(title, key));

export { mockImages };
